export const AUTH_API_URL = `${process.env.NX_SERVER_URL}auth`;
